var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",class:_vm.className,on:{"click":_vm.handleClick}},[_vm._t("default"),(_vm.hasTooltip)?_c('q-tooltip',[_vm._v(" "+_vm._s(_vm.tooltip)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }